import * as Actions from '../actions';
// TODO REFACTOR HERE

const initialState = {
	extractedLinks: [],
	list: [],
	cluster: null,
	queue: {
		counts: {
			blocked: 0,
			completed: 0,
			queued: 0,
			running: 0,
			total: 0
		},
		data: []
	},
	nodes: {
		counts: {
			available: 0,
			busy: 0,
			down: 0,
			offline: 0,
			total: 0,
			unknown: 0
		},
		data: []
	},
	node: null,
	activities: [],
	logs: null,
	logsClusterId: null, // Track which cluster the current logs belong to
	selected: null,
	searchText: '',
	filter: null,
	error: null,
	aiErrorAnalysis: null,
	os_types: [],
	storageProviders: [],
	storageProvidersLoading: false,
	storageProvidersError: null,
	// Enhanced Volumez policy management state
	providerPolicies: {}, // { providerId: policies[] }
	providerPoliciesLoading: {}, // { providerId: boolean }
	providerPoliciesError: {}, // { providerId: error }
	selectedPolicies: {}, // { providerId: policyName }
	policyConstraints: {}, // { providerId: { policyName: constraints } }
	policyConstraintsLoading: {}, // { providerId: { policyName: boolean } }
	policyConstraintsError: {}, // { providerId: { policyName: error } }
	configurationValidation: {}, // { providerId: validationResult }
	configurationValidationLoading: {}, // { providerId: boolean }
	clusterHealthData: {},
	clusterHealthLoading: false,
	gpuMetrics: {
		data: null,
		summary: null,
		loading: false,
		error: null
	},
	clusterMetrics: {
		data: null,
		history: [],
		loading: false,
		error: null
	},
	stressTests: {
		data: null,
		history: null,
		volumes: null,
		loading: false,
		error: null
	},
	preconfiguredDevices: [],
	// Instance availability by zone
	zoneAvailability: {
		zones: {},
		provider: null,
		region: null,
		instanceTypes: [],
		timestamp: null,
		loading: false,
		error: null,
		unableToVerify: false
	}
};

const clusterReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_OS_TYPES: {
			return {
				...state,
				error: null,
				os_types: action.payload
			};
		}
		// SET
		case Actions.SET_CLUSTERS_LIST: {
			return {
				...state,
				list: action.payload
			};
		}
		case Actions.SET_CLUSTER: {
			const { cluster, queue, nodes } = action.payload;
			return {
				...state,
				cluster: cluster,
				queue: {
					counts: queue ? queue.counts : {},
					data: queue ? queue.data : []
				},
				nodes: {
					counts: nodes ? nodes.counts : {},
					data: nodes ? nodes.data : []
				},
				error: null
			};
		}
		case Actions.SET_MARKET_CLUSTER: {
			const { cluster, queue, nodes } = action.payload;
			return {
				...state,
				cluster: cluster,
				queue: {
					counts: queue ? queue.counts : {},
					data: queue ? queue.data : []
				},
				nodes: {
					counts: nodes ? nodes.counts : {},
					data: nodes ? nodes.data : []
				},
				error: null
			};
		}

		case Actions.SET_CLUSTER_TOKEN: {
			return {
				...state,
				token: action.payload
			};
		}

		case Actions.SET_CLUSTER_ACTIVITIES: {
			return {
				...state,
				activities: action.payload,
				error: null
			};
		}
		case Actions.SET_LOGS: {
			// Only update logs if they belong to the current cluster or no specific cluster is tracking
			const { logs, clusterId } = action.payload;
			return {
				...state,
				logs: logs,
				logsClusterId: clusterId,
				error: null
			};
		}
		case Actions.SET_LOG_URLS: {
			return {
				...state,
				extractedLinks: action.payload
			}
		}
		case Actions.SET_NODE: {
			return {
				...state,
				node: action.payload,
				error: null
			};
		}
		case Actions.SET_SELECTED: {
			return {
				...state,
				selected: action.payload
			};
		}

		case Actions.SET_CLUSTERS_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText
			};
		}
		case Actions.SET_FILTER: {
			return {
				...state,
				filter: action.payload
			};
		}
		case Actions.SET_CLUSTER_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.SET_AI_ERROR_ANALYSIS: {
			return {
				...state,
				aiErrorAnalysis: action.payload
			};
		}

		// STORAGE PROVIDERS
		case Actions.SET_STORAGE_PROVIDERS: {
			return {
				...state,
				storageProviders: action.payload,
				storageProvidersError: null,
				storageProvidersLoading: false
			};
		}
		case Actions.SET_STORAGE_PROVIDERS_LOADING: {
			return {
				...state,
				storageProvidersLoading: action.payload
			};
		}
		case Actions.SET_STORAGE_PROVIDERS_ERROR: {
			return {
				...state,
				storageProvidersError: action.payload,
				storageProvidersLoading: false
			};
		}
		case Actions.CLEAR_STORAGE_PROVIDERS: {
			return {
				...state,
				storageProviders: [],
				storageProvidersError: null,
				storageProvidersLoading: false
			};
		}

		// VOLUMEZ POLICY MANAGEMENT
		case Actions.SET_PROVIDER_POLICIES: {
			const { providerId, policies } = action.payload;
			return {
				...state,
				providerPolicies: {
					...state.providerPolicies,
					[providerId]: policies
				},
				providerPoliciesError: {
					...state.providerPoliciesError,
					[providerId]: null
				}
			};
		}
		case Actions.SET_PROVIDER_POLICIES_LOADING: {
			const { providerId, loading } = action.payload;
			return {
				...state,
				providerPoliciesLoading: {
					...state.providerPoliciesLoading,
					[providerId]: loading
				}
			};
		}
		case Actions.SET_PROVIDER_POLICIES_ERROR: {
			const { providerId, error } = action.payload;
			return {
				...state,
				providerPoliciesError: {
					...state.providerPoliciesError,
					[providerId]: error
				}
			};
		}
		case Actions.SET_SELECTED_POLICY: {
			const { providerId, policyName } = action.payload;
			return {
				...state,
				selectedPolicies: {
					...state.selectedPolicies,
					[providerId]: policyName
				}
			};
		}
		case Actions.SET_POLICY_CONSTRAINTS: {
			const { providerId, policyName, constraints } = action.payload;
			return {
				...state,
				policyConstraints: {
					...state.policyConstraints,
					[providerId]: {
						...state.policyConstraints[providerId],
						[policyName]: constraints
					}
				}
			};
		}
		case Actions.SET_POLICY_CONSTRAINTS_LOADING: {
			const { providerId, policyName, loading } = action.payload;
			return {
				...state,
				policyConstraintsLoading: {
					...state.policyConstraintsLoading,
					[providerId]: {
						...state.policyConstraintsLoading[providerId],
						[policyName]: loading
					}
				}
			};
		}
		case Actions.SET_POLICY_CONSTRAINTS_ERROR: {
			const { providerId, policyName, error } = action.payload;
			return {
				...state,
				policyConstraintsError: {
					...state.policyConstraintsError,
					[providerId]: {
						...state.policyConstraintsError[providerId],
						[policyName]: error
					}
				}
			};
		}
		case Actions.SET_CONFIGURATION_VALIDATION: {
			const { providerId, validationResult } = action.payload;
			return {
				...state,
				configurationValidation: {
					...state.configurationValidation,
					[providerId]: validationResult
				}
			};
		}
		case Actions.SET_CONFIGURATION_VALIDATION_LOADING: {
			const { providerId, loading } = action.payload;
			return {
				...state,
				configurationValidationLoading: {
					...state.configurationValidationLoading,
					[providerId]: loading
				}
			};
		}
		case Actions.RESET_POLICY_VALIDATION: {
			const { providerId } = action.payload;
			return {
				...state,
				selectedPolicies: {
					...state.selectedPolicies,
					[providerId]: null
				},
				policyConstraints: {
					...state.policyConstraints,
					[providerId]: {}
				},
				configurationValidation: {
					...state.configurationValidation,
					[providerId]: null
				}
			};
		}

		case Actions.SET_CLUSTER_HEALTH_DATA: {
			return {
				...state,
				clusterHealthData: action.payload
			};
		}
		case Actions.SET_CLUSTER_HEALTH_LOADING: {
			return {
				...state,
				clusterHealthLoading: action.payload
			};
		}
		case Actions.CLEAR_CLUSTER_HEALTH_DATA: {
			return {
				...state,
				clusterHealthData: {},
				clusterHealthLoading: false
			};
		}

		// CLEAR
		case Actions.CLEAR_CLUSTER: {
			return {
				...state,
				cluster: null,
				error: null
			};
		}
		case Actions.CLEAR_CLUSTER_LIST: {
			return {
				...state,
				list: null,
				clusterHealthData: {},
				error: null
			};
		}
		case Actions.CLEAR_LOGS: {
			return {
				...state,
				logs: null,
				logsClusterId: null
			};
		}
		case Actions.CLEAR_AI_ERROR_ANALYSIS: {
			return {
				...state,
				aiErrorAnalysis: null
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_CLUSTER_REDUCER: {
			return initialState;
		}
		case Actions.SET_GPU_METRICS: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					data: action.payload
				}
			};
		}
		case Actions.SET_GPU_METRICS_SUMMARY: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					summary: action.payload
				}
			};
		}
		case Actions.SET_GPU_METRICS_LOADING: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					loading: action.payload
				}
			};
		}
		case Actions.SET_GPU_METRICS_ERROR: {
			return {
				...state,
				gpuMetrics: {
					...state.gpuMetrics,
					error: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					data: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS_HISTORY: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					history: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS_LOADING: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					loading: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_METRICS_ERROR: {
			return {
				...state,
				clusterMetrics: {
					...state.clusterMetrics,
					error: action.payload
				}
			};
		}
		case Actions.CLEAR_CLUSTER_METRICS: {
			return {
				...state,
				clusterMetrics: {
					data: null,
					history: [],
					loading: false,
					error: null
				}
			};
		}
		// STRESS TESTS
		case Actions.SET_STRESS_TEST_DATA: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					data: action.payload
				}
			};
		}
		case Actions.SET_STRESS_TEST_LOADING: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					loading: action.payload
				}
			};
		}
		case Actions.SET_STRESS_TEST_ERROR: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					error: action.payload
				}
			};
		}
		case Actions.SET_STRESS_TEST_HISTORY: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					history: action.payload
				}
			};
		}
		case Actions.SET_CLUSTER_VOLUMES: {
			return {
				...state,
				stressTests: {
					...state.stressTests,
					volumes: action.payload
				}
			};
		}
		case Actions.SET_PRECONFIGURED_DEVICES: {
			return {
				...state,
				preconfiguredDevices: action.payload
			};
		}
		// Zone Availability
		case Actions.SET_ZONE_AVAILABILITY: {
			return {
				...state,
				zoneAvailability: {
					...state.zoneAvailability,
					zones: action.payload.zones,
					provider: action.payload.provider,
					region: action.payload.region,
					instanceTypes: action.payload.instanceTypes,
					timestamp: action.payload.timestamp,
					unableToVerify: action.payload.unableToVerify || false,
					error: action.payload.error || null
				}
			};
		}
		case Actions.SET_ZONE_AVAILABILITY_LOADING: {
			return {
				...state,
				zoneAvailability: {
					...state.zoneAvailability,
					loading: action.payload
				}
			};
		}
		case Actions.SET_ZONE_AVAILABILITY_ERROR: {
			return {
				...state,
				zoneAvailability: {
					...state.zoneAvailability,
					error: action.payload
				}
			};
		}
		case Actions.CLEAR_ZONE_AVAILABILITY: {
			return {
				...state,
				zoneAvailability: {
					zones: {},
					provider: null,
					region: null,
					instanceTypes: [],
					timestamp: null,
					loading: false,
					error: null,
					unableToVerify: false
				}
			};
		}
		// DEFAULT
		default: {
			return state;
		}
	}
};

export default clusterReducer;
